<div class="referral-wrapper current-referrals">
	<div class="referral-ready with-request-appointment">
		<div class="row">
			<div class="col-md-12">
				<!-- Not present in latest wireframe -->
				<!-- <div class="r-p-title-container">
          <div class="title">
            <h2 [translate]="'referral.referral-ready.title'">Referral Ready</h2>
          </div>
          <div class="addons" *ngIf="!noData">
            <a (click)="print()">
              <i class="fa fa-print"></i>
            </a>
          </div>
        </div> -->
				<div class="r-p-title-container">
					<div class="title">
						<p *ngIf="data && !noData" [translate]="'referral.referral-ready.description'">
							Your referral has been sent to our Referral Team. You will be notified when the referral is ready.
						</p>
					</div>
					<span class="addons" *ngIf="!noData">
						<a (click)="print()" appEheAnalytics [data]="analyticsData">
							<i class="fa fa-print"></i>
						</a>
					</span>
				</div>
			</div>
		</div>
		<div class="row" *ngIf="data && isCurrentReferral">
			<div class="col-md-12">
				<ng-container *ngFor="let category of data.category; let categoryIndex = index">
					<ng-container *ngFor="let referral of category.referral; let referralIndex = index">
						<div class="c-r-module">
							<mat-accordion>
								<mat-expansion-panel>
									<mat-expansion-panel-header>
										<div class="title">
											<h3>{{ referral.specialtyName }}</h3>
											<p>Last updated: {{ referral.lastUpdatedDate }}</p>
										</div>
									</mat-expansion-panel-header>
									<mat-panel-description>
										<div class="c-r-content">
											<ng-container *ngFor="let provider of referral.provider; let i = index">
												<div class="c-r-row">
													<div *ngIf="provider.id" class="c-r-r-label">
														<div class="address-checkbox">
															<div>
																<b>{{ provider.name }}</b>
															</div>
															<span>{{ provider.practiceName }}</span>
															<div>
																<span>{{ provider.address }}, {{ provider.address2 }}</span>
																<span>{{ provider.city }}, {{ provider.state }} {{ provider.zip }}</span>
															</div>
															<div *ngIf="provider.phone && provider.phone !== 'null'">
																<span>{{ provider.phoneExtension }}</span>
																<span>{{ provider.phoneExtension ? ' - ' : '' }}</span>
																<span>{{ provider.phone }}</span>
															</div>
															<p>
																<span class="link" [translate]="'referral.directions.title'" class="non-clickable">
																	Directions & Map</span
																>
															</p>
														</div>
													</div>
													<div class="c-r-r-val p-l-10">
														<div [innerHtml]="provider.note"></div>
													</div>
												</div>
											</ng-container>
											<div class="row pb-2 pt-2">
												<div class="col-md-12"></div>
											</div>
										</div>
									</mat-panel-description>
								</mat-expansion-panel>
							</mat-accordion>
						</div>
					</ng-container>
				</ng-container>
				<ng-container *ngIf="noData">
					<div class="align-center">{{ noDataMsg }}</div>
				</ng-container>
			</div>
		</div>
		<div class="row" *ngIf="data && !isCurrentReferral">
			<div class="col-md-12">
				<ng-container *ngFor="let category of data.category">
					<ng-container *ngFor="let referral of category.referral">
						<div class="c-r-module">
							<mat-accordion>
								<mat-expansion-panel>
									<mat-expansion-panel-header>
										<div class="title">
											<h3>{{ referral.specialtyName }}</h3>
											<p>Last updated: {{ referral.lastUpdatedDate }}</p>
										</div>
									</mat-expansion-panel-header>
									<mat-panel-description>
										<div class="c-r-content">
											<ng-container *ngIf="!isCurrentReferral">
												<ng-container *ngFor="let provider of referral.provider">
													<div class="c-r-row">
														<div class="c-r-r-label">
															<div class="address-checkbox">
																<div>
																	<b>{{ provider.name }}</b>
																</div>
																<span>{{ provider.practiceName }}</span>
																<span>{{ provider.address }}, {{ provider.address2 }}</span>
																<span>{{ provider.city }}, {{ provider.state }} {{ provider.zip }}</span>
																<div *ngIf="provider.phone && provider.phone !== 'null'">
																	<span>{{ provider.phoneExtension }}</span>
																	<span>{{ provider.phoneExtension ? ' - ' : '' }}</span>
																	<span>{{ provider.phone }}</span>
																</div>
																<div
																	class="link non-clickable with-request-appointment d-block"
																	[translate]="'referral.directions.title'">
																	Directions & Map
																</div>
															</div>
														</div>
														<div class="c-r-r-val p-l-10">
															<div class="m-l-30" [innerHtml]="provider.note"></div>
														</div>
													</div>
												</ng-container>
											</ng-container>
										</div>
									</mat-panel-description>
								</mat-expansion-panel>
							</mat-accordion>
						</div>
					</ng-container>
				</ng-container>
				<ng-container *ngIf="noData">
					<div class="align-center">{{ noDataMsg }}</div>
				</ng-container>
			</div>
		</div>
	</div>
</div>
